__turbopack_context__.v({
  "earningsChartWrapper": "VeNhRq_earningsChartWrapper",
});
